import { GridItem } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const StyledImageContainer = styled(GridItem) `
  img {
    max-width: 100%;
    width: 100%;
    min-height: 210px;
    height: 100%;
    border-radius: ${({ theme }) => theme.spacing[100]};
  }
`;
//# sourceMappingURL=ImageContainer.styled.js.map